<div class="find-my-fit-card">
  <div class="card-header">
    <iris-icon name="sparkles" [size]="iconSizes.MD" class="sparkles-icon"></iris-icon>
    <div class="text">
      <h2 class="header-text">{{ displayedChipGroup().title }}</h2>
      @if (displayedChipGroup().subtitle) {
        <p class="header-subtitle">{{ displayedChipGroup().subtitle }}</p>
      }
    </div>
  </div>

  <div class="chip-container">
    @for (chip of displayedChipGroup().chips; track chip) {
      <button (click)="toggleChip(chip)" class="chip" [class.selected]="isChipSelected(chip)">{{ chip.title }}</button>
    }
  </div>

  <div class="footer">
    <button (click)="onFindMyFitClicked()" class="iris-button iris-button--primary button">Find my fit</button>
  </div>
</div>

